import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = exact({
  handleButtonClick: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
});

function AddressPicker({ handleButtonClick, items }) {
  return (
    <div className="AddressPicker">
      {items.length > 0 && !items[0].Error && (
        <div className="AddressPicker_content">
          <h3 className="AddressPicker_title">Please select your address</h3>
          <ul className="AddressPicker_list">
            {items.map((item) => (
              <li key={item.Id} className="AddressPicker_item">
                <button
                  type="button"
                  className="AddressPicker_button"
                  onClick={() => handleButtonClick(item)}
                >
                  {item.Type === 'Address' && item.Text}
                  {item.Type === 'Postcode' && `Did you mean: ${item.Description}`}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      {items.length < 1 ||
        (items.length === 1 && items[0].Error && (
          <div className="AddressPicker_noResults">
            Sorry, we could not find a matching address.
            <br />
            Please search again or enter your address manually.
          </div>
        ))}
    </div>
  );
}

AddressPicker.propTypes = propTypes;

export default AddressPicker;
